// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel de formation historique, géographique, économique et sociale
// https://ifpc-fwb.be/v5/documents/tc/refFHGES.pdf
// SHA-256 71d50efd3a1683c56b8c09121777055e0b2711b3335eafe60487367da1f220f5
// P3: pages 42-45, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "FHGES-P3-786156ec",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "",
    text: "Se situer au XXIe siècle.",
  },
  {
    id: "FHGES-P3-e45c0f7d",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des durées : - des siècles : les XXe et XXIe siècles ; - des décennies.",
    text: "Associer des membres d’une famille donnée au XXe et/ou au XXIe siècle.",
  },
  {
    id: "FHGES-P3-5d1f57dc",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des durées : - des siècles : les XXe et XXIe siècles ; - des décennies.",
    text: "Associer une décennie à des années.",
  },
  {
    id: "FHGES-P3-a5597fde",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Les générations : - les enfants ; - les parents ; - les grands-parents ; - les arrière-grands-parents.",
    text: "Se situer et situer ses proches parmi les générations.",
  },
  {
    id: "FHGES-P3-1f11b442",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des réalités d’aujourd’hui : - diversité de la mobilité (y compris douce) ; - accès instantané à l’information et à la communication ; - diversité des loisirs, des voyages ; - impacts sur l’environnement : infrastructures routières, embouteillages, consommation d’énergie, pollution…",
    text: "Expliquer un changement dans les habitudes de vie durant les années 1910-1930, les années 1940-1970, les années 1980-2010.",
  },
  {
    id: "FHGES-P3-06e84446",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des réalités d’aujourd’hui : - diversité de la mobilité (y compris douce) ; - accès instantané à l’information et à la communication ; - diversité des loisirs, des voyages ; - impacts sur l’environnement : infrastructures routières, embouteillages, consommation d’énergie, pollution…",
    text: "Énoncer des innovations technologiques qui ont changé les habitudes de vie durant les années 1910-1930, les années 1940-1970, les années 1980-2010.",
  },
  {
    id: "FHGES-P3-540c796d",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des faits marquants : 1914-1918 : Première Guerre mondiale. 1940-1945 : Deuxième Guerre mondiale en Belgique. 1969 : premiers pas sur la Lune. Années 90 : essor d’Internet.",
    text: "Associer un fait marquant à un moment clé.",
  },
  {
    id: "FHGES-P3-aec2c337",
    champ: "",
    section: "REPÈRES TEMPORELS",
    kind: "Savoir",
    parent: "Des faits marquants : 1914-1918 : Première Guerre mondiale. 1940-1945 : Deuxième Guerre mondiale en Belgique. 1969 : premiers pas sur la Lune. Années 90 : essor d’Internet.",
    text: "Dater les deux guerres mondiales en Belgique.",
  },
  {
    id: "FHGES-P3-f3463cb0",
    champ: "",
    section: "VOCABULAIRE ET NOTIONS POUR APPRÉHENDER LE TEMPS",
    kind: "Savoir",
    parent: "Vocabulaire lié à la chronologie : - du temps de…, à l’époque de…",
    text: "Utiliser le vocabulaire et les notions pour décrire la dimension temporelle (chronologie, durée) de faits vécus par soi ou par des personnes proches.",
  },
  {
    id: "FHGES-P3-527885c9",
    champ: "",
    section: "VOCABULAIRE ET NOTIONS POUR APPRÉHENDER LE TEMPS",
    kind: "Savoir",
    parent: "Des unités de temps liées à la durée : - décennie, siècle.",
    text: "Différencier la durée d’une décennie et d’un siècle.",
  },
  {
    id: "FHGES-P3-3cd4397a",
    champ: "",
    section: "VOCABULAIRE SPÉCIFIQUE DE L’HISTORIEN",
    kind: "Savoir",
    parent: "Trace du passé.",
    text: "Caractériser la notion de trace du passé.",
  },
  {
    id: "FHGES-P3-4301ad22",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir",
    parent: "Trace du passé.",
    text: "Lier des savoirs culturels à un moment clé. Lier le 11 novembre à l’Armistice de la Première Guerre mondiale et à la commémoration de la fin des deux guerres mondiales.",
  },
  {
    id: "FHGES-P3-31632f2e",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir",
    parent: "- Patrimoine lié aux Guerres mondiales : exemples issus du patrimoine local (ex. : monuments aux morts de la localité, journaux intimes…). - Commémoration du 11 novembre. - Albert Ier. - Élisabeth. - Léopold III. - Un(e) acteur/actrice, individuel(le) ou collectif(ve), de lutte pour la liberté (ex. : Gabrielle Petit, Marguerite Bervoets, Fernand Demany, le Soldat inconnu…).",
    text: "Associer les noms des rois et reines belges à l’époque des deux guerres mondiales.",
  },
  {
    id: "FHGES-P3-13e09667",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "UTILISER UNE REPRÉSENTATION DU TEMPS/UN",
    text: "Montrer l’orientation temporelle de la frise chronologique.",
  },
  {
    id: "FHGES-P3-737fd90e",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser une représentation linéaire du temps : la frise chronologique des XXe et XXIe siècles.",
    text: "Montrer sur une frise chronologique graduée les périodes correspondant au XXe et au XXIe siècle.",
  },
  {
    id: "FHGES-P3-c382c09b",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser une représentation linéaire du temps : la frise chronologique des XXe et XXIe siècles.",
    text: "Montrer sur une frise chronologique graduée une période correspondant à une décennie donnée.",
  },
  {
    id: "FHGES-P3-025fb014",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser une représentation linéaire du temps : la frise chronologique des XXe et XXIe siècles.",
    text: "Lire une frise chronologique graduée pour dater une information.",
  },
  {
    id: "FHGES-P3-4af2b6b6",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser une représentation linéaire du temps : la frise chronologique des XXe et XXIe siècles.",
    text: "Compléter une frise chronologique graduée en décennies avec un repère temporel donné.",
  },
  {
    id: "FHGES-P3-410b32ab",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser un arbre généalogique simple (quatre générations).",
    text: "Identifier une génération sur un arbre généalogique.",
  },
  {
    id: "FHGES-P3-804858b4",
    champ: "",
    section: "SAVOIRS CULTURELS",
    kind: "Savoir-faire",
    parent: "Utiliser un arbre généalogique simple (quatre générations).",
    text: "Relever une date de naissance/une date de décès sur un arbre généalogique.",
  },
  {
    id: "FHGES-P3-558265d2",
    champ: "",
    section: "UTILISER UN OUTIL D’INFORMATION",
    kind: "Savoir-faire",
    parent: "Recueillir des informations.",
    text: "Interroger une personne proche pour caractériser des habitudes de vie d’autrefois.",
  },
  {
    id: "FHGES-P3-8f88a441",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Savoir-faire",
    parent: "Observer une trace du passé.",
    text: "Associer une trace du passé à une habitude de vie.",
  },
  {
    id: "FHGES-P3-c977dcaf",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Savoir-faire",
    parent: "Situer une trace du passé dans le temps.",
    text: "Dater une trace du passé grâce à sa référence.",
  },
  {
    id: "FHGES-P3-00fe7eab",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Savoir-faire",
    parent: "Situer une trace du passé dans le temps.",
    text: "Associer, grâce à sa référence, une trace du passé à un repère temporel.",
  },
  {
    id: "FHGES-P3-ec20716c",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Compétence",
    parent: "Mobiliser des repères de temps et des représentations du temps pour se situer soi-même, pour situer des faits dans le temps et mettre en évidence une chronologie, des changements, des continuités.",
    text: "Compléter une frise chronologique graduée en décennies du XXe siècle à aujourd’hui par des documents en lien avec la thématique de l’année et l’annoter en mobilisant des repères temporels significatifs.",
  },
  {
    id: "FHGES-P3-d576db8a",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Compétence",
    parent: "Porter un regard critique sur des traces du passé et des travaux postérieurs.",
    text: "Sélectionner, parmi des photos anciennes ou des objets, une trace du passé en lien avec une habitude de vie des années 1910-1930, des années 1940-1970 ou des années 1980-2010.",
  },
  {
    id: "FHGES-P3-d2c7d25e",
    champ: "",
    section: "LIRE ET EXPLOITER DES DOCUMENTS",
    kind: "Compétence",
    parent: "Inscrire dans une perspective historique une réalité d’aujourd’hui, en mettant en évidence des continuités, des changements et des étapes d’une évolution entre hier et aujourd’hui.",
    text: "Sur la base de deux ou trois documents traitant des habitudes de vie, compléter un tableau à simple entrée pour comparer une habitude de vie de l’élève avec celle vécue par un autre au XXe siècle, et identifier des éléments qui changent et des éléments qui ne changent pas.",
  },
];
